<template>
  <v-container fluid :class="containerClass">
    <v-card class="w-100 config-page-shell-card">
      <div v-if="showBackToSetup" class="config-page-shell-back">
        <BackToSetupLink :to="backTo" :label="backLabel" />
      </div>

      <v-card-title
        class="d-flex justify-space-between align-center flex-wrap ga-3 config-page-shell-header"
      >
        <div class="config-page-shell-title">
          {{ title }}
        </div>
        <div v-if="$slots.actions" class="config-page-shell-actions">
          <slot name="actions" />
        </div>
      </v-card-title>

      <v-card-subtitle v-if="subtitle" class="config-page-shell-subtitle">
        {{ subtitle }}
      </v-card-subtitle>

      <v-card-text class="pt-0">
        <v-divider class="config-page-shell-divider" />

        <slot name="belowHeader" />
        <slot />
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import BackToSetupLink from '@/components/navigation/BackToSetupLink.vue'

const props = withDefaults(
  defineProps<{
    title: string
    subtitle?: string
    showBackToSetup?: boolean
    backTo?: string
    backLabel?: string
    dense?: boolean
  }>(),
  {
    subtitle: '',
    showBackToSetup: true,
    backTo: '/setup',
    backLabel: 'Back to Setup',
    dense: false,
  },
)

const containerClass = computed(() => (props.dense ? 'pa-0 pa-md-4 py-12 py-md-4' : 'pa-0 pa-md-4 py-12'))
</script>

<style scoped>
.config-page-shell-card {
  background: rgb(var(--v-theme-surface));
  overflow: visible;
}

.config-page-shell-back {
  padding: 12px 16px 0;
}

.config-page-shell-header {
  position: sticky;
  top: var(--v-layout-top, 64px);
  z-index: 100;
  background: rgb(var(--v-theme-surface));
  border-bottom: 1px solid rgba(var(--v-border-color), var(--v-border-opacity));
  padding: 12px 16px;
}

.config-page-shell-title {
  line-height: 1.2;
  font-size: 1.25rem;
  font-weight: 700;
}

.config-page-shell-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}

.config-page-shell-subtitle {
  display: block;
  white-space: normal;
  color: rgba(var(--v-theme-on-surface), 0.62);
  font-size: 0.875rem;
  line-height: 1.35;
  opacity: 1;
  padding: 12px 16px 0;
}

.config-page-shell-divider {
  margin: 16px 0 24px;
  opacity: 0.3;
}
</style>
